import React, { FC, useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'store/hooks';
import { ThunkGetChats } from 'store/chats/thunks';
import { PortalConfigSelector } from 'store/config/selectors';
import { dropNotification, setActiveChat as setActiveChatToStore } from 'store/chats';

import { CHATS, CHAT } from 'router/routes';

import Loader from 'components/Loader';
import ChatBody from './components/ChatBody';
import ChatHeader from './components/ChatHeader';
import SLABanner from 'components/SLABanner';

import useStyles from './styles';

const Chats: FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [activeChat, setActiveChat] = useState<number>(0);

  const config = useAppSelector(PortalConfigSelector);
  const dispatch = useAppDispatch();
  const classes = useStyles();
  const navigate = useNavigate();

  const onChatSelection = useCallback(
    (chatId: number) => {
      setActiveChat(chatId);
      dispatch(setActiveChatToStore(chatId));
      dispatch(dropNotification(chatId));
      navigate(CHAT.replace(':chatId', `${chatId}`));
    },
    [dispatch, navigate],
  );

  const onMount = useCallback(async () => {
    dispatch(ThunkGetChats({ search: '' }))
      .unwrap()
      .then(res => {
        const chatId = window.location.pathname.split('/').pop();
        if (chatId === CHATS || !chatId || isNaN(+chatId)) {
          onChatSelection(+res[0].id);
        }
      })
      .finally(() => {
        if (loading) {
          setLoading(false);
        }
      });
  }, [dispatch]);

  useEffect(() => {
    onMount().then();
  }, [onMount]);

  useEffect(() => {
    if (window.location.pathname.includes(CHATS)) {
      const chatId = window.location.pathname.split('/').pop();
      if (chatId) {
        setActiveChat(+chatId);
      }
    }
  }, []);

  if (config.disableChats) return null;
  if (loading) return <Loader />;

  return (
    <div className={classes.container}>
      {!!activeChat && (
        <div className={classes.chatBox}>
          <SLABanner />
          <ChatHeader activeChat={activeChat} />
          <ChatBody activeChatId={activeChat} />
        </div>
      )}
    </div>
  );
};

export default Chats;
